/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteData
 */
export interface DeleteData {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteData
     */
    dryRun?: boolean;
}

/**
 * Check if a given object implements the DeleteData interface.
 */
export function instanceOfDeleteData(value: object): value is DeleteData {
    return true;
}

export function DeleteDataFromJSON(json: any): DeleteData {
    return DeleteDataFromJSONTyped(json, false);
}

export function DeleteDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteData {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
    };
}

export function DeleteDataToJSON(json: any): DeleteData {
    return DeleteDataToJSONTyped(json, false);
}

export function DeleteDataToJSONTyped(value?: DeleteData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
    };
}

